import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    updateError: 'An error occurred while updating the wallet.',
  },
  fr: {
    updateError:
      'Une erreur est survenue lors de la modification de votre compte.',
  },
} as const);

export default locales;
